import Swiper from 'swiper';

export default {
  init() {
    //sliders
    // eslint-disable-next-line
    var salesSliderGallery = new Swiper('.gallery-init', {
      slidesPerView: 4,
      spaceBetween: 16,
      direction: 'vertical',
      breakpoints: {
        991: {
          direction: 'horizontal',
        },
      },
    });
    // eslint-disable-next-line
    var salesSliderPicture = new Swiper('.picture-init', {
      thumbs: {
        swiper: salesSliderGallery,
      },
    });
  },
  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
